<template>
    <div class="loan_wrap">
        <div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('我的融资') }}</div>
		</div>
        <div class="top_card">
            <div class="tt">
                <div class="tl">
                    <span>{{ $t('我的融资') }}</span>
                    <span>{{ loan_amount }}</span>
                </div>
                <!-- <div :class="['tr', !isEn && 'en_tr']">
                    <span>{{ $t('申请贷款') }}</span>
                </div> -->
            </div>
            <div class="tb">
                <div class="item" v-for="(item, index) of cardList" :key="index">
                    <span>
                        {{ item.value }}
                        <em>{{ index == 0 ? $t('天') : '' }}</em>
                    </span>
                    <span>{{ item.title }}</span>
                </div>
            </div>
        </div>
        <!-- 贷款记录 -->
        <div class="loan_history">
            <div class="title">{{ $t('融资记录') }}</div>
            <ul>
                <li v-for="(item, index) of loanHistory" :key="index">
                    <img src="@/assets/images/icon.png" alt="">
                    <div class="content">
                        <div class="top">
                            <div class="tleft">
                                <span>{{ item.amount }}</span>
                                <span>{{ $t('申请日期') }}: {{ times(item.createtime) }}</span>
                                <span v-if="item.status === 2 && item.fail_msg">{{ $t('驳回原因') }}: <span class="color_r">{{ item.fail_msg }}</span></span>
                            </div>
                            <div class="btn" @click="handleRepayment(item, item.id)" v-if="item.status === 1 && item.repayment_status === 1">
                                <button v-if="item.status === 1 && item.repayment_status === 1">{{ $t('还款') }}</button>
                                <!-- <button v-else-if="item.status == 4">
                                    {{ $t('重新申请') }}
                                </button> -->
                            </div>
                            <div class="null" v-else>--</div>
                        </div>
                        <div class="btm">
                            <span>
                                {{ $t('还款周期') }}:
                                {{ item.repayment_day_text }}
                            </span>
                            <span>{{ $t('固定利率') }}: {{item.interest_rate+'%' }}</span>
                            <span :class="{'color_y':item.status === 0,'color_g':item.status === 1,'color_r':item.status === 2}">{{ item.status_text }}</span>
                        </div>
                    </div>
                </li>
            </ul>
            <van-empty v-if="!loanHistory.length" :description="$t('暂无数据')" />
        </div>

        <!-- 底部 -->
        <footers></footers>
    </div>
</template>

<script>
import Fetch from '../../utils/fetch';
import { Toast, Icon } from 'vant'
import footers from '@/components/bsFooter.vue'
export default {
    components:{
        footers
    },
    data() {
        return {
            loan_amount:0,
            cardList: [
                { title: this.$t('已融资'), value: 0 },
                { title: this.$t('产生利息'), value: '--' },
                { title: this.$t('预计还款'), value: '--' },
            ],
            loanHistory:[],
            info:{}
        }
    },
    async created() {
        this.$parent.footer('item', false);
        Fetch("/loan/info").then((r) => {
            if(r.code == 1) {
                this.$set( this.cardList[0],'value',r.data.borrowed_days)
                this.$set( this.cardList[1],'value',r.data.interest)
                this.$set( this.cardList[2],'value',r.data.expected_repayment)
                this.loan_amount = r.data.loan_amount
            }else {
                Toast(r.info)
            }
		});   
        Fetch("/loan/list").then((r) => {
            this.loanHistory = r.data.list
		});   
    },
    computed : {
        applyAmount() {
            let num = 0 
            if(this.loanHistory.length > 0) {
                this.loanHistory.forEach(x => {
                    let nums = x.amount.split(',').join('')
                    num +=  Number(nums)
                })
            }else {
                num = 0
            }
            num = this.formatNumberWithCommas(num)
            return num
        }
    },
    methods: {
        formatNumberWithCommas(number) {
            // 处理非数字输入
            if (isNaN(number) || number === null || number === undefined) {
            return '0';
            }
            
            // 将输入转换为字符串
            const numStr = String(number);
            
            // 分离整数和小数部分
            const parts = numStr.split('.');
            const integerPart = parts[0];
            const decimalPart = parts.length > 1 ? `.${parts[1]}` : '';
            
            // 添加千位分隔符
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            
            // 合并整数和小数部分
            return formattedInteger + decimalPart;
        },
         // 还款按钮
         handleRepayment(item, id) {
            if(item.repayment_status === 1){
                this.$router.push('/loanRepayment?creditId=' + id)
            }
        },
        priceFormat(num, int) {
            if (num && Number(num)) {
                const numStr = _toFixed(num, 2)
                const numPre = numStr.slice(0, numStr.indexOf('.'))
                const numRi = numStr.slice(numStr.indexOf('.') + 1)
                const intStr = numPre.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                const floatStr = numRi ? `.${numRi.length < 2 ? numRi + '0' : numRi}` : '.00'
                return int ? `${intStr}` : `${intStr}${floatStr}`
            } else {
                return 0
            }
        },
        times(timestamp) {
            if (!timestamp) return '';
            
            const date = new Date(timestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        }
    }
}
</script>

<style lang="scss" scoped>
.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
}
.loan_wrap {
    width: 100%;
    height: 100%;
    font-size: 14px;
    padding-top: 44px;
    background: #F3F5F9;
    .top_card {
        width: 345px;
        height: 160px;
        background: #fff;
        margin: 11px auto;
        border-radius: 4px;
        padding: 15px;
        box-sizing: border-box;

        &.en_card {
            height: 170px;
        }

        .tt {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .tl {
                display: flex;
                flex-direction: column;
                width: 100%;
                justify-content: center;
                align-items: center;

                span {
                    &:nth-child(1) {
                        font-weight: 600;
                        font-size: 16px;

                    }

                    &:nth-child(2) {
                        margin-top: 10px;
                        font-weight: 600;
                        font-size: 20px;
                        color: #F89900;
                    }
                }
            }

            .tr {
                width: 109px;
                height: 34px;
                background: #F89900;
                border-radius: 4px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                font-weight: 500;
                font-size: 14px;

                &.en_tr {
                    width: 115px;
                    height: 36px;
                }
            }
        }

        .tb {
            margin-top: 22px;
            padding: 0 20px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;

            .item {
                display: flex;
                flex-direction: column;
                // justify-content: center;
                // align-items: center;
                flex: 0 0 33%;
                text-align: center;

                &:nth-child(1) {
                    transform: translateX(-15px);
                }

                &:nth-child(3) {
                    transform: translateX(15px);
                }

                &.en_item {

                    &:nth-child(3) {
                        transform: translate(15px, 7.5px);
                    }

                    &:nth-child(2) {
                        transform: translate(0, 7.5px);
                    }
                }

                span {
                    em {
                        font-size: 14px;
                        font-style: normal;
                    }

                    &:nth-child(1) {
                        font-weight: 600;
                        font-size: 18px;
                        color: #F89900;
                    }

                    &:nth-child(2) {
                        margin-top: 6px;
                        font-weight: 400;
                        font-size: 12px;
                        color: #999999;
                    }
                }
            }
        }
    }
}
.loan_history {
        margin-top: 19px;
        padding: 0 14px 0 16px;
        min-height: 55vh;

        .title {
            margin-bottom: 11px;
            color: #333;
            font-size: 12px;
        }

        ul {
            width: 100%;

            li {
                width: 100%;
                min-height: 87px;
                border-radius: 4px;
                background: #fff;
                margin-bottom: 12px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px 16px 10px 15px;
                box-sizing: border-box;

                &.en_li {
                    position: relative;
                    height: 115px;

                    img {
                        transform: translateY(-20px);
                    }

                    .content {
                        display: flex;
                        flex-direction: column;

                        .top {
                            flex: 0 0 50%;
                            display: flex;

                            .tleft {
                                span {
                                    &:nth-child(2) {
                                        transform: scale(.97) translateX(-28px);
                                    }
                                    &:nth-child(3) {
                                        transform: scale(.97) translateX(-28px);
                                    }
                                }
                            }

                            .btn {
                                position: absolute;
                                top: 11px;
                                right: 0;
                                padding: 0 5px;
                                min-width: 70px;
                                min-height: 29px;
                                font-size: 10px;
                                border-radius: 4px 0 0 4px;

                                span {
                                    transform: scale(.9);
                                }
                            }
                        }

                        .btm {
                            flex: 0 0 50%;
                            display: flex;
                            flex-direction: column;
                            position: relative;

                            span {
                                &:nth-child(1) {
                                    transform: none;
                                    font-size: 14x;
                                    margin-bottom: 4px;
                                    transform: translateX(-26px) scale(0.8);
                                    em {
                                        margin-left: 2px;
                                        font-size: 12x;
                                    }
                                }

                                &:nth-child(2) {
                                    transform: none;
                                    font-size: 14x;
                                    margin: 0;
                                    transform: translateX(-26px) scale(0.8);
                                }

                                &:nth-child(3) {
                                    position: absolute;
                                    top: 50%;
                                    right: 7px;
                                    transform: translateY(-50%) scale(0.8);
                                }
                            }
                        }
                    }
                }

                img {
                    flex: 0 0 30px;
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                    transform: translateY(-14px);
                }

                .content {
                    flex: 1;
                    width: 100%;

                    .top {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding-bottom: 8px;
                        border-bottom: 1px solid #F3F3F3;

                        .tleft {
                            display: flex;
                            flex-direction: column;

                            span {
                                &:nth-child(1) {
                                    color: #333;
                                    font-size: 16px;
                                    font-weight: 700;
                                    line-height: 19px;
                                }

                                &:nth-child(2) {
                                    margin-top: 1px;
                                    color: #999;
                                    font-weight: 500;
                                    font-size: 14px;
                                    text-align: start;
                                    margin-top: 2px;
                                    transform: scale(.85) translateX(-15px);
                                }
                                &:nth-child(3) {
                                    margin-top: 1px;
                                    color: #999;
                                    font-weight: 500;
                                    font-size: 14px;
                                    text-align: start;
                                    transform: scale(.85) translateX(-15px);
                                }
                            }
                        }
                        .null {
                            width: 83px;
                            height: 24px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }

                        .btn {
                            width: 83px;
                            height: 24px;
                            background:#F89900;
                            border-radius: 4px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            color: #fff;
                            font-weight: 500;
                            font-size: 13px;
                            // border: 1px solid#F89900;

                            button {
                                width: 83px;
                                height: 24px;
                                background: transparent;
                                border: none;
                                border-radius: 4px;
                                font-weight: 400;
                                &.disabled {
                                    // opacity: .6;
                                    background: #EDEDED;
                                    color: #AEAEAE;

                                }
                            }

                            &.again {
                                background: linear-gradient(0deg, #FFF7EC, #FFF7EC), #EEEEEE;
                                color:#F89900;
                            }
                        }
                    }

                    .btm {
                        margin-top: 6px;

                        span {
                            color: #999;
                            line-height: 14px;
                            font-size: 14px;
                            transform: scale(.85) translateX(-5px);
                            display: inline-block;

                            // &:nth-child(2) {
                            //     margin: 0 30px 0 15px;
                            // }

                            &:last-child {
                                color: #3F80FF;
                                font-size: 14px;
                                transform: scale(0.85);
                                transform: scale(.85) translateX(-5px);
                            }
                        }
                    }
                }
            }
        }
    }
    .footers {
        padding-bottom: 0px;
    }
    .color_y {
        color: #F89900 !important;
    } 
    .color_g {
        color: #1aa343 !important;
    }
    .color_r {
        color: #f73c23 !important;
    }
</style>